import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(100);
const savedMinimalSchema = z.string().max(100);
const schema = z.string().max(100);
const savedSchema = z.string().max(100);
const jsonSchema = z.string();
/**
 * 開催場所(値オブジェクト)のメタデータ。
 *
 *  */
export const venueMeta = new ValueObjectMetaString(
  "Venue",
  "\u958B\u50AC\u5834\u6240",
  messageId("lbl.\u958B\u50AC\u5834\u6240"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
